// This is a wrapper to make importing the encrypted channel capable web build
// nicer
// import Pusher from 'pusher-js/with-encryption'
module.exports = require('../dist/web/pusher-with-encryption');



//////////////////
// WEBPACK FOOTER
// ./node_modules/pusher-js/with-encryption/index.js
// module id = wAAc
// module chunks = 0